export default __webpack_public_path__ + "static/media/_DSC0574.58586c0d.JPG";